import { cn } from '@/shared/lib/utils'

interface PointsScoreboardProps {
  /** Pontos que o aluno de fato conquistou no escopo. */
  acquiredPoints: number
  /** Teto de pontos do escopo (jornada ou nível). */
  totalPoints: number
  size?: 'sm' | 'md' | 'lg'
  className?: string
}

const sizeVariants = {
  sm: { text: 'text-sm', icon: 'size-4' },
  md: { text: 'text-md', icon: 'size-5' },
  lg: { text: 'text-lg lg:text-xl', icon: 'size-6 lg:size-7' }
} as const

/**
 * Placar de aproveitamento: quanto o aluno conquistou sobre o teto do escopo
 * (ex: `150/300 pts`). Torna visível o que ficou pelo caminho em respostas
 * erradas — o progresso percentual sozinho não mostra isso.
 *
 * Escopo sem nada a pontuar não renderiza nada: `0/0` não informa.
 */
export function PointsScoreboard({
  acquiredPoints,
  totalPoints,
  size = 'md',
  className
}: PointsScoreboardProps) {
  const total = Math.round(totalPoints)

  if (total <= 0) return null

  const acquired = Math.round(acquiredPoints)

  const variant = sizeVariants[size]

  return (
    <div
      className={cn(
        'flex items-center gap-1.5 select-none',
        variant.text,
        className
      )}
      aria-label={`Aproveitamento de pontos: ${acquired} de ${total}`}
    >
      <img src="/icons/star.svg" alt="" aria-hidden className={variant.icon} />
      {/* font-hl (Funnel Display): token do DS para score/número gamificado. */}
      <span className="font-hl font-bold leading-none" aria-hidden>
        <span className="text-secondary">{acquired}</span>
        <span className="text-american-blue">/{total} pts</span>
      </span>
    </div>
  )
}
